import * as React from "react";
import { IconProps } from "./IconProps";

export const IconExpand = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="expand, arrow, enlarge">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.33333 3.33333C8.96514 3.33333 8.66667 3.03486 8.66667 2.66667C8.66667 2.29848 8.96514 2 9.33333 2H13.3333C13.7015 2 14 2.29848 14 2.66667V6.66667C14 7.03486 13.7015 7.33333 13.3333 7.33333C12.9651 7.33333 12.6667 7.03486 12.6667 6.66667V4.27614L9.80474 7.13807C9.54439 7.39842 9.12228 7.39842 8.86193 7.13807C8.60158 6.87772 8.60158 6.45561 8.86193 6.19526L11.7239 3.33333H9.33333ZM2.66667 8.66667C3.03486 8.66667 3.33333 8.96514 3.33333 9.33333V11.7239L6.19526 8.86193C6.45561 8.60158 6.87772 8.60158 7.13807 8.86193C7.39842 9.12228 7.39842 9.54439 7.13807 9.80474L4.27614 12.6667H6.66667C7.03486 12.6667 7.33333 12.9651 7.33333 13.3333C7.33333 13.7015 7.03486 14 6.66667 14H2.66667C2.29848 14 2 13.7015 2 13.3333V9.33333C2 8.96514 2.29848 8.66667 2.66667 8.66667Z"
            fill={color}
          />
        </g>
      </svg>
    );
  }
);
